import React from 'react';
const links = [{
  label: 'Practice',
  href: '#practice'
}, {
  label: 'Ventures',
  href: '#ventures'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Nav() {
  return <header className="sticky top-0 z-40 border-b border-rule/70 bg-paper/85 backdrop-blur-sm" data-id="element-54" data-mp="16z90bo1s74zk">
      <nav aria-label="Primary" className="mx-auto flex h-16 max-w-page items-center justify-between gap-6 px-6 lg:px-10" data-id="element-55" data-mp="1b0ciwib7rf4h">
        <a href="#top" className="whitespace-nowrap font-sans text-[13px] font-semibold uppercase tracking-overline text-ink transition-colors duration-150 ease-out hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-paper" data-id="element-56" data-mp="1fz5x6cybra5p">
          Prashanth Sekhar
        </a>

        <ul className="flex items-center gap-5 sm:gap-8" data-id="element-57" data-mp="1yrhwsrxlfxc5">
          {links.map(link => <li key={link.href} data-id="element-58" data-mp="23qb9wj8yxmbs">
              <a href={link.href} className="whitespace-nowrap font-sans text-[13px] text-ink-soft transition-colors duration-150 ease-out hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-paper" data-id="element-59" data-mp="23n6zv58tnwd7">
                {link.label}
              </a>
            </li>)}
        </ul>
      </nav>
    </header>;
}